import React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { GearIcon } from '@revfluence/fresh-icons/regular/esm';
import { OFFER_SOURCE } from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { AutomatePayoutsDrawer } from './AutomatePayoutsDrawer';
import { IRefreshPayoutProps } from '../../../../utils/OfferFormUtils';
import { IPayoutVariant } from '../../../../types';

export const AutomatePayoutsButton: React.FC<Readonly<Partial<IRefreshPayoutProps>>> = (props) => {
  const sortPayoutOptionsByThreshold = (options: IPayoutVariant[]): IPayoutVariant[] => {
    return [...options].sort((a, b) => {
      // Handle null/undefined cases - put them at the end
      if (a.automationThreshold === null || a.automationThreshold === undefined) return 1;
      if (b.automationThreshold === null || b.automationThreshold === undefined) return -1;

      // Handle 0 case - put it first
      if (a.automationThreshold === 0) return -1;
      if (b.automationThreshold === 0) return 1;
      // Sort remaining by threshold ascending
      return a.automationThreshold - b.automationThreshold;
    });
  };
  let isAutomatedPayoutEnabled = false;
  if (props.source === OFFER_SOURCE.SHOPIFY) {
    isAutomatedPayoutEnabled = props.shopifyData?.offerAutomationConfig?.isActive;
  } else {
    isAutomatedPayoutEnabled = props.affiliateLinkData?.offerAutomationConfig?.isActive;
  }
  const offerDetails = props.affiliateLinkData || props.shopifyData;

  const sortedOfferPayoutOptions = sortPayoutOptionsByThreshold(offerDetails.payoutOptions || []);
  offerDetails.payoutOptions = sortedOfferPayoutOptions;

  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  return (
    <>
      {isAutomatedPayoutEnabled ? (
        <Button
          variant="default"
          onClick={() => setIsDrawerOpen(true)}
          className="flex h-6 absolute right-4 top-4 w-auto items-center gap-2 bg-slate-600 hover:bg-slate-700 text-white rounded-xl"
          type="button"
        >
          <GearIcon className="w-4 h-4" />
          Automated Payout
        </Button>
      ) : (
        <Button
          variant="ghost"
          onClick={() => setIsDrawerOpen(true)}
          className="flex items-center gap-1 p-0 h-auto text-primary hover:text-primary"
          type="button"
        >
          <GearIcon className="w-4 h-4" />
          <span className="underline">Automate Payouts</span>
        </Button>
      )}

      {isDrawerOpen && (
        <AutomatePayoutsDrawer
          open={isDrawerOpen}
          onOpenChange={setIsDrawerOpen}
          onCancel={() => setIsDrawerOpen(false)}
          offerDetails={offerDetails}
          handleFormAsyncActions={props.handleFormAsyncActions}
          {...props}
        />
      )}
    </>
  );
};
